import React, { useEffect, useRef, useState } from "react";
import "./portfolio.css";
import { Pagination, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import IMG1 from "../../assets/portfolio/dea.webp";
import IMG2 from "../../assets/portfolio/creationbois-cover.webp";
import IMG3 from "../../assets/portfolio/proview-cover.webp";
import IMG4 from "../../assets/portfolio/f4c.webp";
import IMG5 from "../../assets/portfolio/strofulla-cover.webp";
import IMG6 from "../../assets/portfolio/neuron-cover.webp";
import IMG7 from "../../assets/portfolio/zoomtrip-cover.webp";
import IMG8 from "../../assets/portfolio/ezgif.com-webp-to-jpg.webp";

import IMG_TRIPSIM from "../../assets/portfolio/trip.webp";
import IMG_PLATESPECT from "../../assets/portfolio/plate.webp";
import IMG_FLYCOP from "../../assets/portfolio/fly.webp";
import IMG_DROSPECT from "../../assets/portfolio/dro.webp";

import IMG9 from "../../assets/portfolio/image.webp";
import IMG10 from "../../assets/portfolio/image-row.webp";
import IMG11 from "../../assets/portfolio/crosswordmini.png";
import IMG_FJALKRYQ from "../../assets/portfolio/fjalkryq.webp";

import Arrow from "../../assets/svg/chevron-left.svg";
import { FiExternalLink } from "react-icons/fi";

const ITEMS_PER_PAGE = 6;

const chunkItems = (items, size) => {
  const pages = [];
  for (let index = 0; index < items.length; index += size) {
    pages.push(items.slice(index, index + size));
  }
  return pages;
};

const PORTFOLIO_IMG_WIDTH = 800;
const PORTFOLIO_IMG_HEIGHT = 533;

const portfolioItems = [
  {
    title: "Fjalekryq",
    alt: "Fjalekryq web application preview",
    Live: true,
    LiveDemoLink: "https://fjalekryq.com/",
    description:
      "Full-stack web app — responsive UI, API integrations, and scalable backend architecture.",
    technology: ["React.js", "Next.js", "TypeScript", "Tailwind CSS", "Node.js", "PostgreSQL", "REST APIs", "Vercel"],
    imgSrc: IMG_FJALKRYQ,
    width: PORTFOLIO_IMG_WIDTH,
    height: PORTFOLIO_IMG_HEIGHT,
  },
  {
    title: "TripSIM",
    alt: "TripSIM eSIM platform preview",
    Live: true,
    LiveDemoLink: "https://tripsim.com/",
    description:
      "eSIM store built on WordPress with WooCommerce and Telna API.",
    technology: ["WordPress", "WooCommerce", "PHP", "JavaScript", "Telna API"],
    imgSrc: IMG_TRIPSIM,
    width: PORTFOLIO_IMG_WIDTH,
    height: PORTFOLIO_IMG_HEIGHT,
  },
  {
    title: "PlateSpect",
    alt: "PlateSpect vehicle monitoring platform preview",
    Live: true,
    LiveDemoLink: "https://platespect.com/",
    description:
      "Platform for automatic license plate detection and live vehicle tracking.",
    technology: ["React.js", "Tailwind", "Python", "FastAPI", "Supabase", "PostgreSQL"],
    imgSrc: IMG_PLATESPECT,
    width: PORTFOLIO_IMG_WIDTH,
    height: PORTFOLIO_IMG_HEIGHT,
  },
  {
    title: "Flycop",
    alt: "Flycop flight compensation platform preview",
    Live: true,
    LiveDemoLink: "https://flycop.com/",
    description:
      "Flight compensation app — submit a claim and track your refund.",
    technology: ["React.js", "Next.js", "TypeScript", "Tailwind", "Node.js", "PostgreSQL"],
    imgSrc: IMG_FLYCOP,
    width: PORTFOLIO_IMG_WIDTH,
    height: PORTFOLIO_IMG_HEIGHT,
  },
  {
    title: "DroSpect",
    alt: "DroSpect inspection platform preview",
    Live: true,
    LiveDemoLink: "https://drospect.ai/",
    description:
      "Drone inspection platform for infrastructure analysis and reporting.",
    technology: ["React.js", "Next.js", "TypeScript", "Python", "FastAPI", "Supabase"],
    imgSrc: IMG_DROSPECT,
    width: PORTFOLIO_IMG_WIDTH,
    height: PORTFOLIO_IMG_HEIGHT,
  },
  {
    title: "DEA Studio",
    alt: "DEA project preview",
    Live: true,
    LiveDemoLink: "https://deastudio.de/",
    description:
      "Design studio website — fast, clean, and SEO-optimized.",
    technology: ["Tailwind", "TypeScript", "Next.js", "React.js", "Node.js"],
    imgSrc: IMG1,
    width: PORTFOLIO_IMG_WIDTH,
    height: PORTFOLIO_IMG_HEIGHT,
  },
  {
    title: "Creation Bois",
    alt: "Creation Bois project preview",
    Live: true,
    LiveDemoLink: "https://creationbois.ch/",
    description:
      "E-commerce with 3D product customizer — users configure and buy in real-time.",
    technology: ["Tailwind", "Three.js", "React.js", "WordPress", "Stripe"],
    imgSrc: IMG2,
    width: PORTFOLIO_IMG_WIDTH,
    height: PORTFOLIO_IMG_HEIGHT,
  },
  {
    title: "Proview360",
    alt: "Proview360 project preview",
    Live: true,
    LiveDemoLink: "https://proview360.ch/",
    description:
      "Marketing site with 3D scenes and scroll animations.",
    technology: ["Tailwind", "Next.js", "Three.js", "React.js", "Node.js"],
    imgSrc: IMG3,
    width: PORTFOLIO_IMG_WIDTH,
    height: PORTFOLIO_IMG_HEIGHT,
  },
  {
    title: "FightForCure",
    alt: "FightForCure project preview",
    Live: false,
    LiveDemoLink: "https://fightforcure.com/",
    description:
      "E-commerce store with Stripe payments — built for launch.",
    technology: ["Tailwind", "TypeScript", "Next.js", "React.js", "Stripe"],
    imgSrc: IMG4,
    width: PORTFOLIO_IMG_WIDTH,
    height: PORTFOLIO_IMG_HEIGHT,
  },
  {
    title: "Strofulla",
    alt: "Strofulla project preview",
    Live: true,
    LiveDemoLink: "https://strofulla.com/",
    description:
      "Product aggregator — compare prices across multiple shops.",
    technology: ["Tailwind", "TypeScript", "Next.js", "React.js", "PHP"],
    imgSrc: IMG5,
    width: PORTFOLIO_IMG_WIDTH,
    height: PORTFOLIO_IMG_HEIGHT,
  },
  {
    title: "Neuron",
    alt: "Neuron project preview",
    Live: false,
    LiveDemoLink: "https://dribbble.com/Alien_pixels",
    description:
      "Internal management dashboard for tasks and operations.",
    technology: ["Tailwind", "TypeScript", "React.js", "PHP"],
    imgSrc: IMG6,
    width: PORTFOLIO_IMG_WIDTH,
    height: PORTFOLIO_IMG_HEIGHT,
  },
  {
    title: "ZoomTrip",
    alt: "ZoomTrip project preview",
    Live: true,
    LiveDemoLink: "https://zoomtrip.vercel.app/",
    description:
      "Travel booking platform — browse destinations and book trips.",
    technology: ["Tailwind", "Next.js", "TypeScript", "React.js"],
    imgSrc: IMG7,
    width: PORTFOLIO_IMG_WIDTH,
    height: PORTFOLIO_IMG_HEIGHT,
  },
  {
    title: "CollectorApp",
    alt: "CollectorApp project preview",
    Live: false,
    LiveDemoLink: "https://zoomtrip.vercel.app/",
    description:
      "Debt collection CRM for managing cases and follow-ups.",
    technology: ["Tailwind", "TypeScript", "React.js", "PHP"],
    imgSrc: IMG8,
    width: PORTFOLIO_IMG_WIDTH,
    height: PORTFOLIO_IMG_HEIGHT,
  },
];

const gameItems = [
  {
    title: "4 in a Row",
    alt: "4 in a Row game preview",
    Live: true,
    LiveDemoLink: "https://rrath-rrath.netlify.app/",
    description:
      "Classic 4-in-a-row with a built-in opponent. Try to beat it.",
    technology: ["React.js", "TypeScript", "Tailwind", "Firebase"],
    imgSrc: IMG9,
    width: 800,
    height: 533,
  },
  {
    title: "Wordle",
    alt: "Albanian Wordle clone preview",
    Live: true,
    LiveDemoLink: "https://luaj.live/",
    description:
      "Albanian Wordle — guess the word in 6 tries.",
    technology: ["React.js", "TypeScript", "Tailwind"],
    imgSrc: IMG10,
    width: 828,
    height: 552,
  },
  {
    title: "Mini CrossWord",
    alt: "Mini CrossWord game preview",
    Live: true,
    LiveDemoLink: "https://mini-crossword.netlify.app/",
    description:
      "Quick mini crossword — built for short puzzle breaks.",
    technology: ["React.js", "TypeScript", "Tailwind"],
    imgSrc: IMG11,
    width: 1421,
    height: 910,
  },
];

const Portfolio = ({
  title = "Portfolio",
  subtitle = "My Recent Work",
  game = false,
}) => {
  const [page, setPage] = useState(0);
  const swiperRef = useRef(null);
  const items = game ? portfolioItems : gameItems;
  const pages = chunkItems(items, ITEMS_PER_PAGE);
  const sectionId = game ? "portfolio" : "fun-projects";
  const headingId = game ? "portfolio-heading" : "fun-projects-heading";

  useEffect(() => {
    const lastPageIndex = Math.max(0, pages.length - 1);
    if (page > lastPageIndex) {
      setPage(lastPageIndex);
      swiperRef.current?.slideTo(lastPageIndex, 0);
    }
  }, [page, pages.length]);

  return (
    <section id={sectionId} aria-labelledby={headingId}>
      {subtitle && <h5>{subtitle}</h5>}
      <h2 id={headingId}>{title}</h2>

      <div className="container portfolio__container">
        {pages.length > 1 && (
          <div className="portfolio__nav portfolio__nav--left">
            <button
              onClick={() => swiperRef.current?.slidePrev()}
              className="portfolio__nav-button"
              aria-label="Previous page"
              disabled={page === 0}
            >
              <img src={Arrow} alt="" className="portfolio__nav-icon" />
            </button>
          </div>
        )}

        {pages.length > 1 && (
          <div className="portfolio__nav portfolio__nav--right">
            <button
              onClick={() => swiperRef.current?.slideNext()}
              className="portfolio__nav-button"
              aria-label="Next page"
              disabled={page === pages.length - 1}
            >
              <img src={Arrow} alt="" className="portfolio__nav-icon portfolio__nav-icon--next" />
            </button>
          </div>
        )}

        <Swiper
          modules={[Pagination, A11y]}
          slidesPerView={1}
          speed={500}
          allowTouchMove={pages.length > 1}
          pagination={pages.length > 1 ? { clickable: true } : false}
          className="portfolio__swiper"
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
            setPage(swiper.activeIndex);
          }}
          onSlideChange={(swiper) => setPage(swiper.activeIndex)}
        >
          {pages.map((pageItems, pageIndex) => (
            <SwiperSlide
              className="portfolio__slide"
              key={`${sectionId}-${pageIndex}`}
            >
              <div className="portfolio__page">
                {pageItems.map((item) => (
                  <article key={item.title} className="portfolio__item glass pixel-corners">
                    <div className="portfolio__item-image">
                      <img
                        src={item.imgSrc}
                        alt={item.alt}
                        width={item.width}
                        height={item.height}
                        loading="lazy"
                      />
                      {item.Live && (
                        <a
                          href={item.LiveDemoLink}
                          target="_blank"
                          rel="noreferrer"
                          className="portfolio__item-overlay"
                          aria-label={`View ${item.title} live`}
                        >
                          <FiExternalLink />
                          <span>View Live</span>
                        </a>
                      )}
                    </div>

                    <div className="portfolio__item-body">
                      <h3 className="portfolio__item-title">{item.title}</h3>
                      <p className="portfolio__item-description">
                        {item.description}
                      </p>
                      <div className="portfolio__tech-list">
                        {item.technology?.map((tech) => (
                          <span
                            key={`${item.title}-${tech}`}
                            className="portfolio__tech-pill"
                          >
                            {tech}
                          </span>
                        ))}
                      </div>
                      <div className="portfolio__item-cta">
                        {item.Live ? (
                          <a
                            href={item.LiveDemoLink}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-primary portfolio__item-btn"
                          >
                            View Live
                            <FiExternalLink className="btn__icon" />
                          </a>
                        ) : (
                          <span className="portfolio__item-status">
                            Not Live
                          </span>
                        )}
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Portfolio;
